import api, {apiTs} from '../../../services/api';

export const WhoIsInHTTP = {
  getV1: (params = {}) => api.get('/who-is-in', {params}),
  get: (params = {}) => apiTs.get('/trackmyguys', {params}),
};
